function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getLocalTimeZone, parseAbsolute, toCalendarDate, today } from "@internationalized/date";
import RenderIfChildExists from "@sprout/client-components/dist/RenderIfChildExists";
import { useCurrentUser } from "@sprout/client-graphql";
import { useCallback, useMemo } from "react";
import { useTopicPage_UpdateSettingsMutation } from "sprout-graphql";
import { Button } from "sprout-ui-dom";
import { Text, Flex } from "sprout-ui-primitives";
import styled from "styled-components";
import useTopicAuthorization from "../useTopicAuthorization";
const TopicPageViewsTopicListSettingsWrapper = styled(Flex)`
  > * + * {
    margin-top: 16px;
  }
`;
// `Post` with `whenOrDeadline` > `Today` is considered `Later`
function getNodesLaterPostCount(posts, timezone) {
    return posts.reduce((acc, currentValue)=>{
        const whenOrDeadline = currentValue.when || currentValue.deadline;
        if (!whenOrDeadline) return acc;
        if (toCalendarDate(parseAbsolute(whenOrDeadline, timezone)).compare(today(timezone)) > 0) return acc + 1;
        return acc;
    }, 0);
}
const TopicPageViewsTopicListSettings = (props)=>{
    const { topic  } = props;
    const { settings , id  } = topic.rootTopicOrSelf || {};
    var ref2;
    const hideCompleted = (ref2 = settings === null || settings === void 0 ? void 0 : settings.hideCompleted) !== null && ref2 !== void 0 ? ref2 : true;
    var ref1;
    const hideLater = (ref1 = settings === null || settings === void 0 ? void 0 : settings.__hideLater) !== null && ref1 !== void 0 ? ref1 : false;
    const currentUser = useCurrentUser();
    const authorization = useTopicAuthorization(topic);
    const [updateSettingsMutation] = useTopicPage_UpdateSettingsMutation();
    const updateSettings = useCallback((setting)=>{
        updateSettingsMutation({
            variables: {
                topicId: Number(id),
                settings: _objectSpread({}, settings, setting)
            }
        });
    }, [
        id,
        settings,
        updateSettingsMutation
    ]);
    const toggleHideCompleted = useCallback(()=>{
        updateSettings({
            hideCompleted: !hideCompleted
        });
    }, [
        hideCompleted,
        updateSettings
    ]);
    const toggleHideLater = useCallback(()=>{
        updateSettings({
            __hideLater: !hideLater
        });
    }, [
        hideLater,
        updateSettings
    ]);
    const completedPostCount = useMemo(()=>{
        var _checklistItemCompletedCount1;
        return ((_checklistItemCompletedCount1 = topic.checklistItemCompletedCount) !== null && _checklistItemCompletedCount1 !== void 0 ? _checklistItemCompletedCount1 : 0) + topic.sections.nodes.reduce((acc, currentValue)=>{
            var _checklistItemCompletedCount;
            return acc + ((_checklistItemCompletedCount = currentValue.checklistItemCompletedCount) !== null && _checklistItemCompletedCount !== void 0 ? _checklistItemCompletedCount : 0);
        }, 0);
    }, [
        topic.checklistItemCompletedCount,
        topic.sections.nodes
    ]);
    const laterPostCount = useMemo(()=>{
        var ref;
        const timezone = (ref = currentUser === null || currentUser === void 0 ? void 0 : currentUser.timezone) !== null && ref !== void 0 ? ref : getLocalTimeZone();
        return getNodesLaterPostCount(topic.posts.nodes, timezone) + topic.sections.nodes.reduce((acc, currentValue)=>{
            return acc + getNodesLaterPostCount(currentValue.posts.nodes, timezone);
        }, 0);
    }, [
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.timezone,
        topic.posts.nodes,
        topic.sections.nodes
    ]);
    if (!authorization.editHideCompleted) return null;
    return /*#__PURE__*/ _jsxs(RenderIfChildExists, {
        component: /*#__PURE__*/ _jsx(TopicPageViewsTopicListSettingsWrapper, {
            flexDirection: "column",
            alignItems: "flex-start",
            mt: 8
        }),
        children: [
            laterPostCount !== 0 && /*#__PURE__*/ _jsx(Button, {
                onClick: toggleHideLater,
                children: /*#__PURE__*/ _jsx(Text, {
                    as: "span",
                    fontWeight: "medium",
                    color: "black.54",
                    children: hideLater ? "Show later items" : "Hide later items"
                })
            }),
            completedPostCount !== 0 && /*#__PURE__*/ _jsx(Button, {
                onClick: toggleHideCompleted,
                children: /*#__PURE__*/ _jsx(Text, {
                    as: "span",
                    fontWeight: "medium",
                    color: "black.54",
                    children: hideCompleted ? `Show ${completedPostCount} completed item${completedPostCount > 1 ? "s" : ""}` : "Hide completed items"
                })
            })
        ]
    });
};
export default TopicPageViewsTopicListSettings;
